import React from 'react';

import { ResolveNickName } from 'api/nickResolveApi';
import { _I_ } from 'components/translate';
import { LogStream } from 'generics/common';
import { IconGlyphicon } from 'generics/icons';

LogStream.enable( "VIEWACHIEVEMENTUSERSEARCH" );

export class ViewAchievementUserSearch extends React.Component  {
  constructor( props )  {
    super( props );
    this.state = {
      "nick": null,
      "notFound": false
    };
  }

  componentDidUpdate(prevProps)  {
    if ( prevProps.usernick != this.props.usernick )
      this.setState({ "nick": this.props.usernick });
  }

  resolveUser ( nick ) {
    return ResolveNickName( nick ).then( ( resolved ) =>  {
      return resolved;
    });
  }

  onNewSearch ()  {
    const nickStr = this.searchInput.value.match(/[a-zA-Z0-9_]+/ig);
    const nick = nickStr ? nickStr.join() : null;

    if ( !nick )
    {
      this.setState({ "notFound": true });
      return;
    }

    if ( nick == this.state.nick )
      return; // no updates

    Promise.all([
      this.resolveUser(nick)
    ]).then( ([resolved]) =>  {

      if (resolved)
      {
        this.props.onUpdate(resolved, nick);
        this.setState({ "nick": nick, "notFound": false });
      }
      else
        this.setState({ "notFound": true });

    }).catch( (error) =>  {
      console.warn( "ViewAchievementUserSearch", error );
    });
  }

  onPressKey (e)  {
    if (e.keyCode == 13)
      this.onNewSearch();
  }

  renderResults () {
    const {  notFound  } = this.state;

    if ( notFound )
    {
      return (
        <div className="user-search-panel-result">
          <i className="glyphicon glyphicon-question-sign"></i> {_I_("ViewItemSearch.resultNotFound")}
        </div>
      );
    }
  }

  render()  {
    return (
      <div>
        <div  className="view-marketed-search-label">
          {_I_("ViewItemSearch.label.search")}
        </div>
        <div  className="view-marketed-search-input-holder">
          <input
              type="text"
              maxLength="32"
              className="form-control input-sm"
              placeholder={_I_("ViewItemSearch.termsPlaceholder")}
              ref={ (searchInput) => {this.searchInput = searchInput;} }
              onKeyUp={ this.onPressKey.bind(this) }
            />
          <div  className="view-marketed-search-search"
                onClick={ () =>  { this.onNewSearch(); } }
              >
            <IconGlyphicon type="search" />
          </div>
        </div>
        {this.renderResults()}
      </div>
    );
  }
}